import React, { Component } from 'react';
import { Form, Control } from 'react-redux-form';

import validators from '../../../../helpers/validators';
import moment from 'moment';

import Textfield from '../../../ui/text-field';
import Textarea from '../../../ui/textarea';
import Checkbox from '../../../ui/checkbox';
import Datepicker from '../../../ui/datepicker';
import Modal from '../../../ui/modal';
import PRModal from '../../../ui/modal-pr-confirm';
import OnSiteDate from './on-site-date';

import validObj from '../../../../helpers/validateObj';
import crossFormValidation from '../../../../helpers/crossFormValidation';

class FormInformation extends Component {
    handleSubmit = e => {
        this.props.updateFormSave(true);
        const formsValidObj = crossFormValidation(e);
        this.props.setInvalidTabs(formsValidObj);
        if (formsValidObj.formsValid) {
            const formObj = validObj(e);
            switch (this.props.userAction) {
                case 'recall':
                    this.props.recallEventThunk();
                    break;
                case 'save':
                    if (formObj.id) {
                        this.props.updateEvent(formObj);
                    } else {
                        this.props.createEvent(formObj);
                    }
                    break;
                case 'submit':
                    let canSubmit = true;
                    if (this.props.onsiteActivations > 0) {
                        if (
                            this.props.onSiteAddDates &&
                            this.props.onSiteAddDates.length === 0
                        ) {
                            canSubmit = false;
                            this.props.setEventErrorMessage(
                                'Please add at least one on-site date.'
                            );
                        }
                    }
                    if (canSubmit) {
                        if (this.canBeInPast()) {
                            if (formObj.cost > 0 && formObj.contract === '0') {
                                if (this.props.prComplete) {
                                    if (
                                        this.props.purchaseRequest
                                            .PurchaseRequestItem.length > 0
                                    ) {
                                        if (formObj.id) {
                                            this.props.updateAndSubmitEvent(
                                                formObj
                                            );
                                        } else {
                                            this.props.createAndSubmitEvent(
                                                formObj
                                            );
                                        }
                                        this.props.updateFormSave(true);
                                    } else if (
                                        this.props.purchaseRequest.totalCost !==
                                            '' &&
                                        this.props.purchaseRequest
                                            .PurchaseRequestItem.length < 1
                                    ) {
                                        this.props.setEventErrorMessage(
                                            'Please add at least 1 Purchase Request Item to the Purchase Request.'
                                        );
                                    } else {
                                        if (formObj.id) {
                                            this.props.updateAndSubmitEvent(
                                                formObj
                                            );
                                        } else {
                                            this.props.createAndSubmitEvent(
                                                formObj
                                            );
                                        }
                                        this.props.updateFormSave(true);
                                    }
                                } else {
                                    this.props.showPRModal();
                                }
                            } else {
                                if (formObj.id) {
                                    if (this.props.status !== 'Incomplete') {
                                        this.props.updateEvent(formObj);
                                    } else {
                                        this.props.updateAndSubmitEvent(
                                            formObj
                                        );
                                    }
                                } else {
                                    this.props.createAndSubmitEvent(formObj);
                                }
                            }
                        } else {
                            canSubmit = false;
                            this.props.setEventErrorMessage(
                                'Fee based events cannot occur in the past.'
                            );
                        }
                    }
                    break;
                case 'reject':
                    this.props.rejectEvent(formObj);
                    break;
                case 'approve':
                    if (this.props.approvers.length === 0) {
                        delete formObj.approverId;
                    }
                    if (this.props.userInfo.Billet.location === 'MCRC') {
                        if (this.props.mcrcUploadedFile) {
                            this.props.updateAndApproveEvent(formObj);
                        } else {
                            this.props.setEventErrorMessage(
                                'Please upload a signature of approval document.'
                            );
                        }
                    } else if (
                        this.props.userInfo.Billet.location === 'Regional' &&
                        this.props.cost.value > 9999
                    ) {
                        if (this.props.regionalUploadedFile) {
                            this.props.updateAndApproveEvent(formObj);
                            this.props.updateFormSave(true);
                        } else {
                            this.props.setEventErrorMessage(
                                'Please upload a signature of approval document.'
                            );
                        }
                    } else if (
                        this.props.userInfo.Billet.location === 'District' &&
                        this.props.cost.value > 9999
                    ) {
                        if (this.props.districtUploadedFile) {
                            this.props.updateAndApproveEvent(formObj);
                            this.props.updateFormSave(true);
                        } else {
                            this.props.setEventErrorMessage(
                                'Please upload a signature of approval document.'
                            );
                        }
                    } else if (this.props.eventApproveReject) {
                        if (
                            this.props.userInfo.Billet.name === 'MPA' ||
                            this.props.userInfo.Billet.name === 'MAC'
                        ) {
                            if (this.props.recommend) {
                                if (this.props.recommend.value === '0') {
                                    if (this.props.recommendReason) {
                                        this.props.updateAndApproveEvent(
                                            formObj
                                        );
                                    } else {
                                        this.props.setEventErrorMessage(
                                            "Please provide a reason you don't recommend this event."
                                        );
                                    }
                                } else {
                                    this.props.updateAndApproveEvent(formObj);
                                }
                            } else {
                                this.props.setEventErrorMessage(
                                    'Please provide a recommendation.'
                                );
                            }
                        } else {
                            this.props.approveEvent(formObj);
                        }
                    } else {
                        this.props.approveEvent(formObj);
                    }
                    break;
                case 'request':
                    this.props.requestInfoEvent(formObj);
                    break;
                case 'update':
                    this.props.updateEvent(formObj);
                    break;
                case 'hideModal':
                    this.props.hidePRModal();
                    break;
                default:
                    console.log(this.props.userAction);
            }
        } else if (this.props.userAction === 'save') {
            const formObj = validObj(e);

            if (formObj.id) {
                this.props.updateEvent(formObj);
            } else {
                this.props.createEvent(formObj);
            }
        }
    };

    handleSubmitFailed = e => {
        this.props.updateFormSave(true);
        if (this.props.userAction === 'save') {
            if (e.name.value && e.sDate.value && e.startTime.value) {
                const mappedValues = {};
                Object.keys(e).forEach(item => {
                    if (e[item].value) {
                        mappedValues[item] = e[item].value;
                    }
                });

                const formObj = validObj(mappedValues);
                if (e.id && e.id.value) {
                    this.props.updateEvent(formObj, []);
                } else {
                    this.props.createEvent(formObj, []);
                }
            }
        } else if (this.props.userAction === 'recall') {
            this.props.recallEventThunk();
        } else if (this.props.userAction === 'reject') {
            const mappedValues = {};
            Object.keys(e).forEach(item => {
                if (e[item].value) {
                    mappedValues[item] = e[item].value;
                }
                if (item === 'vendorsInformation') {
                    const vendors = e[item];
                    mappedValues[item] = [];
                    let newArr = [];
                    for (let val in vendors) {
                        if (val !== '$form') {
                            newArr.push(vendors[val]);
                        }
                    }
                    for (let i = 0; i < newArr.length; i++) {
                        let copyObj = newArr[i];
                        let newObj = {};
                        Object.keys(copyObj).forEach(item => {
                            newObj[item] = copyObj[item].value;
                        });
                        mappedValues[item].push(newObj);
                    }
                }
            });
            const formObj = validObj(mappedValues);
            this.props.rejectEvent(formObj);
        } else if (this.props.userAction === 'submit') {
            const formsValidObj = crossFormValidation(e);
            this.props.setInvalidTabs(formsValidObj);
        }
    };

    canBeInPast = e => {
        let startDate = this.props.startDate;
        let endDate = this.props.endDate;
        let eventCost = this.props.cost.value;
        let currentDate = moment();
        if (startDate < currentDate && endDate < currentDate && eventCost > 0) {
            return false;
        } else {
            return true;
        }
    };

    handleOnsiteChange = e => {
        const val = parseInt(e.target.value, 10);
        this.props.setOnsiteActivations(val);
    };

    render() {
        const empty = validators.empty();
        const required = validators.required();
        const noTrim = validators.noTrim();
        const textVal = validators.trimVal();

        const dateRow = this.props.onSiteAddDates.map((date, index) => {
            return (
                <OnSiteDate
                    key={index}
                    date={date}
                    deleteItem={() => this.props.deleteOnSiteDate(index)}
                    disabled={!this.props.eventSaveSubmit}
                />
            );
        });

        let recallBtnStatus = false;

        if (this.props.status === 'Unapproved') {
            if (this.props.tasks.length >= 1) {
                const tasks = this.props.tasks.filter(
                    task =>
                        task.action === 'Review' && task.status === 'Complete'
                );
                recallBtnStatus =
                    tasks.length < 1 && this.props.userIsCreator ? true : false;
            } else {
                recallBtnStatus = true;
            }
        }

        return (
            <Form
                className="form"
                model="event"
                encType="multipart/form-data"
                onSubmit={this.handleSubmit}
                onSubmitFailed={this.handleSubmitFailed}
            >
                <div className="tab__title">FORM INFORMATION</div>
                <div className="form__row">
                    <div className="form__title">
                        FIELDS BELOW WILL BE USED IN THE GENERATION OF THE
                        MARINE CORPS ADVERTISING REQUEST FORM AND THE MCRC
                        MARKETING ENGAGEMENT CONTRACTS EXCEEDING $10,000 REPORT.
                        REQUIRED FIELDS ARE INDICATED BELOW.
                    </div>
                </div>

                <Textarea
                    model="event.purpose"
                    isRequired={true}
                    title="Purpose"
                    tooltip="What do you hope to accomplish with this event (the goal) and whose awareness and behavior are you trying to affect"
                    validators={{ textVal }}
                    messages={{ textVal: textVal.message }}
                    disabled={!this.props.eventSaveSubmit}
                    maxLength={1000}
                />

                <div className="form__section-title">Awareness & Attitude</div>
                <Checkbox
                    model="event.awareness"
                    options={[
                        { name: 'SELECT IF OBJECTIVE IS AWARENESS', code: '1' }
                    ]}
                    disabled={!this.props.eventSaveSubmit}
                />

                <Textfield
                    model="event.estAttendance"
                    isRequired
                    title="ESTIMATED ATTENDANCE"
                    type="number"
                    tooltip="Number of people you think will attend the event"
                    validators={{ empty }}
                    messages={{ empty: empty.message }}
                    disabled={!this.props.eventSaveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.estEngagements"
                    isRequired
                    title="ESTIMATED NUMBER OF DIRECT ENGAGEMENTS BETWEEN MARINES AND EVENT ATTENDEES"
                    type="number"
                    validators={{ empty }}
                    messages={{ empty: empty.message }}
                    tooltip="Number of people engaged with one-on-one"
                    disabled={!this.props.eventSaveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.estMediaPosts"
                    isRequired
                    title="ESTIMATED NUMBER OF TRADITIONAL MEDIA POSTS"
                    tooltip="Print media articles or insertions, TV/cable features or reports, digital media placements"
                    type="number"
                    validators={{ empty }}
                    messages={{ empty: empty.message }}
                    disabled={!this.props.eventSaveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.estMediaImpressions"
                    isRequired
                    title="ESTIMATED NUMBER OF TRADITIONAL MEDIA IMPRESSIONS"
                    tooltip="Impressions from print, TV/cable, digital"
                    type="number"
                    validators={{ empty }}
                    messages={{ empty: empty.message }}
                    disabled={!this.props.eventSaveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.estSocialMediaPosts"
                    isRequired
                    title="ESTIMATED NUMBER OF SOCIAL MEDIA POSTS"
                    type="number"
                    validators={{ empty }}
                    messages={{ empty: empty.message }}
                    disabled={!this.props.eventSaveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.estSocialMediaImpressions"
                    isRequired
                    title="ESTIMATED NUMBER OF SOCIAL MEDIA IMPRESSIONS"
                    type="number"
                    validators={{ empty }}
                    messages={{ empty: empty.message }}
                    disabled={!this.props.eventSaveSubmit}
                    onKeyPress
                    min="0"
                />

                <div className="form__section-title">BEHAVIOR</div>
                <Checkbox
                    model="event.behavior"
                    options={[
                        { name: 'SELECT IF OBJECTIVE IS BEHAVIOR', code: '1' }
                    ]}
                    disabled={!this.props.eventSaveSubmit}
                />

                <Textfield
                    model="event.estQualifiedLeads"
                    isRequired
                    title="ESTIMATED NUMBER OF QUALIFIED LEADS GENERATED"
                    type="number"
                    validators={{ empty }}
                    messages={{ empty: empty.message }}
                    disabled={!this.props.eventSaveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.estInfluencerContacts"
                    isRequired
                    title="ESTIMATED NUMBER OF INFLUENCER CONTACTS GENERATED"
                    tooltip="Number of coaches, educators, parents, etc. who provided contact information (for entry into ECCI)"
                    type="number"
                    validators={{ empty }}
                    messages={{ empty: empty.message }}
                    disabled={!this.props.eventSaveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.estFollowUps"
                    isRequired
                    title="ESTIMATED NUMBER OF FOLLOW-ON ENGAGEMENTS SCHEDULED"
                    type="number"
                    validators={{ empty }}
                    messages={{ empty: empty.message }}
                    disabled={!this.props.eventSaveSubmit}
                    onKeyPress
                    min="0"
                    tooltip="Number of CFT, school talks, etc. scheduled post-event"
                />

                <Textfield
                    model="event.estInteraction"
                    isRequired
                    title="ESTIMATED NUMBER OF PROSPECTS THAT WILL INTERACT WITH THE MARINE BOOTH OR OTHER ACTIVATION SETUP"
                    type="number"
                    tooltip="Number of prospect-aged youth that interacted with Marines at the activation set up"
                    validators={{ empty }}
                    messages={{ empty: empty.message }}
                    disabled={!this.props.eventSaveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textfield
                    model="event.estInfluencerInteraction"
                    isRequired
                    title="ESTIMATED NUMBER OF INFLUENCERS THAT WILL INTERACT WITH THE MARINE BOOTH OR OTHER ACTIVATION SETUP"
                    type="number"
                    tooltip="Number of coaches, educators, parents, etc. that interacted with Marines at the activation set up"
                    validators={{ empty }}
                    messages={{ empty: empty.message }}
                    disabled={!this.props.eventSaveSubmit}
                    onKeyPress
                    min="0"
                />

                <Textarea
                    model="event.deliverable"
                    isRequired
                    title="DELIVERABLES"
                    tooltip="What paid elements are included in the vendor contract"
                    validators={{ textVal }}
                    messages={{ textVal: textVal.message }}
                    disabled={!this.props.eventSaveSubmit}
                    maxLength={1000}
                />

                <Textarea
                    model="event.addlDeliverables"
                    isRequired
                    title="ADDITIONAL DELIVERABLES"
                    tooltip="What added value elements are part of the contract (i.e. color guard)"
                    validators={{ textVal }}
                    messages={{ textVal: textVal.message }}
                    disabled={!this.props.eventSaveSubmit}
                    maxLength={1000}
                />

                <Textfield
                    model="event.estOnsiteActivations"
                    isRequired
                    title="ESTIMATED ON-SITE ACTIVATIONS"
                    tooltip="How many activations are included in the contract"
                    type="number"
                    validators={{ required }}
                    messages={{ required: required.message }}
                    disabled={!this.props.eventSaveSubmit}
                    onChange={this.handleOnsiteChange}
                    onKeyPress
                    min="0"
                />

                {this.props.onsiteActivations > 0 ? (
                    <div>
                        <div className="form__section-title">
                            ESTIMATED ON-SITE DATES
                        </div>
                        <Datepicker
                            model="event.onSiteDate"
                            tooltip="What are the dates of those activations"
                            title="DATE"
                            validators={validators.onSite(
                                this.props.onSiteAddDates.length
                            )}
                            messages={{ empty: empty.message }}
                            disabled={!this.props.eventSaveSubmit}
                            onBlur={e => {
                                if (
                                    e.target.value &&
                                    moment(e.target.value).isValid()
                                ) {
                                    this.props.addOnSiteDate({
                                        date: moment(e.target.value).toDate()
                                    });
                                }
                            }}
                        />

                        <div className="multiple-dates">{dateRow}</div>
                        <div
                            onClick={() => {
                                if (
                                    this.props.onSiteDate.value &&
                                    moment(
                                        this.props.onSiteDate.value
                                    ).isValid()
                                ) {
                                    this.props.addOnSiteDate({
                                        date: moment(
                                            this.props.onSiteDate.value
                                        ).toDate()
                                    });
                                }
                            }}
                            className="add-dates"
                        >
                            Add Another date
                        </div>
                    </div>
                ) : null}

                <Datepicker
                    model="event.dateContractedSigned"
                    isRequired
                    title="DATE CONTRACTED SIGNED"
                    validators={{ noTrim }}
                    messages={{
                        noTrim: noTrim.message
                    }}
                    disabled={!this.props.eventSaveSubmit}
                />

                <Control.text
                    model="event.hidden"
                    type="hidden"
                    value="eventId"
                />

                <div className="form__actions form__actions--global">
                    {recallBtnStatus && (
                        <Control.button
                            className="btn btn--secondary"
                            model="event.userActionTaken"
                            t
                            ype="submit"
                            onClick={() => {
                                this.props.setEventUserAction('recall');
                            }}
                        >
                            Recall Event
                        </Control.button>
                    )}
                    {this.props.eventSaveSubmit ? (
                        <Control.button
                            className="btn btn--secondary"
                            type="submit"
                            model="event.userActionTaken"
                            value="save"
                            onClick={() => {
                                this.props.setEventUserAction('save');
                            }}
                        >
                            Save
                        </Control.button>
                    ) : null}
                    {this.props.eventSaveSubmit ? (
                        <Control.button
                            className="btn btn--submit"
                            type="submit"
                            model="event.userActionTaken"
                            value="submit"
                            onClick={() => {
                                this.props.setEventUserAction('submit');
                            }}
                        >
                            Submit
                        </Control.button>
                    ) : null}
                    {this.props.eventApproveReject &&
                    this.props.userInfo.permissions.resources.Event.includes(
                        'Reject'
                    ) ? (
                        <Modal
                            title="Reject Event"
                            classes="btn btn--secondary"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.rejectModalActive}
                            toggleModal={this.props.toggleRejectModal}
                            submitAction={this.props.setEventUserAction}
                            submitValue={'reject'}
                        >
                            <div className="form__section-title">
                                Reject Event
                            </div>
                            <Textfield
                                model="event.rejectComments"
                                title="Rejection Comments"
                                maxLength="250"
                            />
                        </Modal>
                    ) : null}
                    {this.props.eventApproveReject ? (
                        <Modal
                            title="Approve"
                            classes="btn btn--submit"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.approveModalActive}
                            toggleModal={this.props.toggleApproveModal}
                            submitAction={this.props.setEventUserAction}
                            submitValue={'approve'}
                        >
                            <div className="form__section-title">
                                Approve Event
                            </div>
                        </Modal>
                    ) : null}
                    {this.props.eventApproveReject ? (
                        <Modal
                            title="Returned for Edit"
                            classes="btn btn--secondary"
                            closeButtonCopy="Cancel"
                            toggleAction={this.props.requestModalActive}
                            toggleModal={this.props.toggleRequestModal}
                            submitAction={this.props.setEventUserAction}
                            submitValue={'request'}
                        >
                            <div className="form__section-title">
                                Returned for Edit
                            </div>
                            <Textfield
                                model="event.rejectComments"
                                title="Comments"
                                maxLength="250"
                            />
                        </Modal>
                    ) : null}
                    <PRModal
                        submitAction={this.props.setEventUserAction}
                        setPRComplete={this.props.setPRComplete}
                        toggleAction={this.props.prModalActive}
                        toggleModal={this.props.hidePRModal}
                    >
                        <div className="form__section-title">
                            Submit without a purchase request?
                        </div>
                        <p>
                            Please confirm you would like to submit this event
                            without a purchase request.
                        </p>
                    </PRModal>
                </div>
            </Form>
        );
    }
}

export default FormInformation;



// WEBPACK FOOTER //
// ./src/components/event/event-details/form-information/index.js